import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import BetterStandsContext from "../../../Components/Contexts/Management/BetterStandsContext";
import {JAVA_BACKEND_API_URL} from "../../../Components/Contexts/BackendConstants";
import { useTranslation } from "react-i18next";

const BetterStandsDataModal = ({ isOpen, toggle, formId, standId, selectedData, categoryId, subId, konuName }) => {
  const { t } = useTranslation("saha");
    const [tehlikeOptions, setTehlikeOptions] = useState([]);
    const [selectedTehlike, setSelectedTehlike] = useState('');
    const [search, setSearch] = useState('');
    // userId localStorage'dan lazy init ile okunuyor — useEffect+setState'e gerek yok
    const [denetmenId, setDenetmenId] = useState(() => localStorage.getItem('userId') || "0");
    const [photo, setPhoto] = useState(null);
    const fileInputRef = useRef(null);
    const { activeFairId, fetchActiveStands, getPostHeader } = useContext(BetterStandsContext);
    const [selectedStand, setSelectedStand] = useState(null);
    const [konuOptions, setKonuOptions] = useState([]);
    const [selectedKonu, setSelectedKonu] = useState('');
    const [selectedFaaliyet, setSelectedFaaliyet] = useState('');
    const [tehlikeName, setTehlikeName] = useState('');

    // useEffect'lerden önce tanımlanması gerekiyor — useCallback ile sabitlendi
    const fetchTehlikeOptions = useCallback(async () => {
        const requestID = selectedKonu ? selectedKonu : subId;
        if (requestID) {
            try {
                const response = await axios.get(`https://fds.sakagrup.com/FormSystem/get_form_tehlikes/${requestID}`);
                setTehlikeName(response.data[1].name);
                setTehlikeOptions(response.data);
            } catch (error) {
                console.error('Error fetching tehlike options:', error);
            }
        }
    }, [selectedKonu, subId]);

    useEffect(() => {
        const fetchKonuOptions = async () => {
            if (formId) {
                try {
                    const response = await axios.get(`https://fds.sakagrup.com/Saha/xGetAllKonus/${formId}`);
                    setKonuOptions(response.data);
                } catch (error) {
                    console.error('Error fetching konu options:', error);
                }
            }
        };

        if (isOpen) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            fetchTehlikeOptions();
            fetchKonuOptions();
        }
    }, [isOpen, subId, formId, fetchTehlikeOptions]);

    // userId artık lazy init'te okunuyor — bu useEffect kaldırıldı

    useEffect(() => {
        if (denetmenId) {
            fetchActiveStands(0, 10, null, search);
        }
    }, [denetmenId, search, fetchActiveStands]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        fetchTehlikeOptions();
    }, [selectedKonu, fetchTehlikeOptions]);

    const loadStandOptions = async (inputValue) => {
        try {
            const page = 0;
            const limit = 10;
            const response = await axios.get(
                `${JAVA_BACKEND_API_URL}/betterStands/standsByFuarIdOpt2/${activeFairId}`,
                {
                    params: { page, limit, salonId: null, search: inputValue }, // search parametresini ekledik
                    headers: {
                        Authorization: getPostHeader.Authorization,
                        "X-token": getPostHeader.authToken,
                        "X-user-id": getPostHeader.userId,
                    },
                }
            );
            return response.data.fullStandInfoDTOS.content.map(stand => ({
                value: stand.standId,
                label: stand.standNumber+" ("+stand.companyName+") ",
            }));
        } catch (error) {
            console.error('Error fetching stand options:', error);
            return [];
        }
    };


    const handleStandChange = (selectedOption) => {
        setSelectedStand(selectedOption);
    };

    const handleKonuChange = (selectedOption) => {
        const sKonu = selectedOption.target.selectedOptions[0];
        setSelectedFaaliyet(sKonu.dataset.code);
        setSelectedKonu(sKonu.value);
    };

    const handleSubmitU = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData();
        formData.append('form_type_id', formId);
        formData.append('form_faaliyet_id', categoryId || selectedFaaliyet);
        formData.append('form_konu_id', selectedKonu || subId);
        formData.append('form_tehlike_id', selectedTehlike);
        formData.append('user_id', denetmenId);
        formData.append('fuar_id', activeFairId);
        formData.append('salon_id', selectedData?.hall || '');
        formData.append('stand_id', selectedStand ? selectedStand.value : standId);
        if (photo) {
            formData.append('photo', photo);
        }

        const postRequest = axios.post('https://fds.sakagrup.com/Saha/xSaveUyumsuzluk?stand_id=' + (selectedStand ? selectedStand.value : standId) + '&saha_form_id=0', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        postRequest.then((response) => {
            console.log('Form submission successful:', response);
            setPhoto(null);
            setSelectedTehlike('');
            setSelectedStand(null);
            setSelectedKonu('');
        })
        toggle();
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setPhoto(e.target.files[0]);
        }
    };

    const handleCameraClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{t("betterStandsDataModal.uygunsuzlukFormu")}</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmitU}>
                    {!selectedData && (
                        <FormGroup>
                            <Label>{t("betterStandsDataModal.standSecimi")}</Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={loadStandOptions}
                                onChange={handleStandChange}
                                value={selectedStand}
                                placeholder={t("betterStandsDataModal.standSeciniz")}
                            />
                        </FormGroup>
                    )}
                    {selectedData && (
                        <>
                            <FormGroup>
                                <Label>{t("betterStandsDataModal.standAdi")}</Label>
                                <Input type="text" value={selectedData.stand_name || ''} disabled />
                            </FormGroup>
                            <FormGroup>
                                <Label>{t("betterStandsDataModal.firmaAdi")}</Label>
                                <Input type="text" value={selectedData.name || ''} disabled />
                            </FormGroup>
                        </>
                    )}
                    <FormGroup>
                        <Label>{t("betterStandsDataModal.konu")}</Label>
                        {konuName ? (
                            <Input type="text" value={konuName} disabled />
                        ) : (
                            <Input
                                type="select"
                                value={selectedKonu}
                                onChange={handleKonuChange}
                            >
                                <option value="">{t("betterStandsDataModal.seciniz")}</option>
                                {konuOptions.map((option) => (
                                    <option key={option.id} data-code={option.category} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </Input>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Label for="tehlikeSelect">{t("betterStandsDataModal.tehlike")}</Label>
                        {tehlikeName? (
                            <Input type="text" value={tehlikeName} disabled />
                        ): (
                            <Input
                                type="select"
                                name="tehlikeSelect"
                                id="tehlikeSelect"
                                value={selectedTehlike}
                                onChange={(e) => setSelectedTehlike(e.target.value)}
                            >
                                <option value="">{t("betterStandsDataModal.seciniz")}</option>
                                {tehlikeOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </Input>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Label for="photoUpload">{t("betterStandsDataModal.fotograf")}</Label>
                        <Input
                            type="file"
                            name="photo"
                            id="photoUpload"
                            accept="image/*"
                            capture="environment"
                            onChange={handleFileChange}
                            innerRef={fileInputRef}
                            style={{ display: 'none' }}
                        />
                        <div className="d-flex">
                            <Button type="button" color="secondary" onClick={() => fileInputRef.current.click()}>
                                {t("betterStandsDataModal.kamera")}
                            </Button>
                        </div>
                        {photo && <div className="mt-2">{t("betterStandsDataModal.secilenDosya")}{" "}{photo.name}</div>}
                    </FormGroup>
                    <Button color="primary" type="submit">{t("common:kaydet")}</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default BetterStandsDataModal;
